import { useCallback, useEffect, useRef } from "react";
import { calendarService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { createUUID } from "@miplatform/utils";
import { useCalendarStore } from "../../stores/calendarsStore/calendarsStore";

const hydrateCalendarSetUUID = createUUID();

export const useDetailedCalendarSet = (
  calendarSetId?: string | null,
  { auto = true }: { auto?: boolean } = {}
) => {
  const stateManager = useComponentState();
  const stateManagerRef = useRef(stateManager);

  const setCalendarSetConfig = useCalendarStore(
    (state) => state.setCalendarSetConfig
  );

  const hydrate = useCallback(() => {
    if (!calendarSetId) return;

    const currentStateManager = stateManagerRef.current;
    currentStateManager.abort(hydrateCalendarSetUUID);

    currentStateManager.run(async (signal: AbortSignal | undefined) => {
      const response = await calendarService.calendarSets.getById({
        id: calendarSetId,
        signal,
      });

      if (response.status === HTTP_STATUSES.OK) {
        setCalendarSetConfig(response.data);
      }
    }, hydrateCalendarSetUUID);
  }, [calendarSetId, setCalendarSetConfig]);

  useEffect(() => {
    stateManagerRef.current = stateManager;
  }, [stateManager]);

  useEffect(() => {
    if (auto) {
      hydrate();
    }
  }, [auto, hydrate]);

  return {
    isHydrating: stateManager.isBusy(),
    refreshCalendarSet: hydrate,
  };
};
